module.exports = __webpack_public_path__ + "media/images/icons/icon_buy-f3edaaabc64d613c4d8008da581adf5d.svg";